module.exports = __webpack_public_path__ + "static/media/user-solid-r.2ffe5a32.svg";